import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService as NgXTranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from "../services/translate.config.service";
import { TITLE_SUFFIX } from "../translate.suffix";
import { TranslatePipe } from "./translate.pipe";
/**
* **********************************************************************
* Pipe that wraps the pipe of ng2-translate.
*
* Written by: Dana Moshe
* **********************************************************************
*/
@Pipe({
	name: 'cpTitleTranslate',
	pure: true
})
export class TitleTranslatePipe implements PipeTransform, OnDestroy{
	public translate:TranslatePipe;

	constructor(private ng2TranslateService:NgXTranslateService,
				private changeDetectorRef:ChangeDetectorRef,
				private translateConfigService: TranslateConfigService) {
		this.translate = new TranslatePipe(ng2TranslateService, changeDetectorRef);
	}

	public ngOnDestroy(): void {
		this.translate.ngOnDestroy();
	}

	transform(query: string, ...args: any[]):any {
		return this.translateConfigService.containsRegisteredTranslateSuffix(query) ?
			this.translate.transform(query, ...args) :
			this.translate.transform(query + TITLE_SUFFIX, ...args);
	}
}
